export default "__VITE_ASSET__e8c634f2__"